/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/drafts/rfa-async-pub-pipeline.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/drafts/rfa-async-pub-pipeline.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/rfa-async-pub-pipeline.mdx';

const metadata = {
  slug: "rfa-async-pub-pipeline",
  title: "RFA: Async Publishing Pipeline",
  author: "Christian Battaglia",
  description: "Lessons learned building Amplify's async publishing pipeline — from PDFer to classroom slides to multi-edition, multi-format curriculum delivery across digital and print contexts.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2019-12-20T00:00:00.000Z",
  
  readTime: "1 min read",
  tags: ["publishing","pipeline","Amplify","curriculum","PDF generation","asynchronous","EdTech","architecture"],
};

export const Route = createFileRoute('/blog/posts/rfa-async-pub-pipeline')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/rfa-async-pub-pipeline',
    image: '/og/blog/rfa-async-pub-pipeline.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
